__turbopack_context__.v({
  "backButton": "PdpBreadcrumb-module__pUgjXa__backButton",
  "container": "PdpBreadcrumb-module__pUgjXa__container",
});
